import { getDefaultRegistry } from '@rjsf/core';
import { type RJSFSchema, FieldProps } from '@rjsf/utils';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '../../../../../utils';

function StringField(props: FieldProps) {
	const { formData, schema } = props as { formData: unknown; schema: RJSFSchema };
	const { fields } = getDefaultRegistry();
	const { t } = useTranslation();
	const { StringField: DefaultStringField } = fields;

	const currentLength = typeof formData === 'string' ? formData.length : 0;
	const schemaHasLengthRules = !!schema.minLength || !!schema.maxLength;

	const rules = useMemo(() => {
		const result: string[] = [];

		const { minLength, maxLength } = schema;

		if (minLength) {
			result.push(t('form.label.minLength', { minLength }));
		}

		if (maxLength) {
			result.push(t('form.label.maxLength', { maxLength }));
		}

		return result;
	}, [schema.minLength, schema.maxLength, t]);

	return (
		<>
			{schemaHasLengthRules && (
				<div
					className={cn('text-xs mt-1 text-brand-gray-2', {
						'text-red-500':
							(!!schema.maxLength && currentLength > schema.maxLength) ||
							(!!schema.minLength && currentLength > 0 && currentLength < schema.minLength),
					})}
				>
					{t('form.label.usedCharacters', {
						count: currentLength,
						rules: rules.join(', '),
					})}
				</div>
			)}
			<DefaultStringField {...props} />
		</>
	);
}

export { StringField };
